import React from "react";
import { useIntl } from "react-intl";
import { Plus } from "react-feather";
import "./styles.scss";

const NewKmlButton = ({ textId, onChange, isLoading, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <button className={`button ${isLoading ? " is-loading" : ""}`}>
        <label className="custom-file-upload">
          <input type="file" accept=".kml" multiple onChange={onChange} />
          <Plus size="12" /> {formatMessage({ id: textId })}
        </label>
      </button>
    </>
  );
};

export default NewKmlButton;
